import { ScoreRow } from '../components/ScoreRow'
import colors from '../config/colors.json'

const Stats = ({ summary, extraInfo }) => {
	return (
		<table className="stats__table">
			<thead className="stats__head">
				<tr>
					<th scope="col" className="stats__header"></th>
					{(extraInfo.leftRelics !== 0 ||
						extraInfo.rightRelics !== 0) && (
						<th
							scope="col"
							className="stats__header stats__header__title"
						>
							Relics
						</th>
					)}

					<th
						scope="col"
						className="stats__header stats__header__title"
					>
						Max Vills
					</th>
					{(summary?.players[0].maxTraders !== 0 ||
						summary?.players[1].maxTraders !== 0) && (
						<th
							scope="col"
							className="stats__header stats__header__title"
						>
							Max Trade
						</th>
					)}
					{(summary?.players[0].maxFishingShips !== 0 ||
						summary?.players[1].maxFishingShips !== 0) && (
						<th
							scope="col"
							className="stats__header stats__header__title"
						>
							Max Fish
						</th>
					)}
					<th
						scope="col"
						className="stats__header stats__header__title"
					>
						APM
					</th>
					<th
						scope="col"
						className="stats__header stats__header__title"
					>
						{summary?.players.length === 2
							? 'ECO Killed'
							: 'ECO Lost'}
					</th>
				</tr>
			</thead>
			<tbody>
				{summary?.players.length === 2 ? (
					<>
						<tr className="stats__row">
							<th
								scope="row"
								className="stats__row__head stats__row__leftHead"
							>
								{summary.players[0].name}
							</th>
							{(extraInfo.leftRelics !== 0 ||
								extraInfo.rightRelics !== 0) && (
								<td className="stats__row__data">
									{extraInfo.leftRelics}
									{extraInfo.leftRelics >
										extraInfo.rightRelics && (
										<span className="text-yellow-400">
											⭐
										</span>
									)}
								</td>
							)}
							<ScoreRow
								players={summary?.players}
								index={0}
								item="maxVillagers"
							/>

							{(summary?.players[0].maxTraders !== 0 ||
								summary?.players[1].maxTraders !== 0) && (
								<ScoreRow
									players={summary?.players}
									index={0}
									item="maxTraders"
								/>
							)}
							{(summary?.players[0].maxFishingShips !== 0 ||
								summary?.players[1].maxFishingShips !== 0) && (
								<ScoreRow
									players={summary?.players}
									index={0}
									item="maxFishingShips"
								/>
							)}
							<ScoreRow
								players={summary?.players}
								index={0}
								item="apm"
							/>
							<ScoreRow
								players={summary?.players}
								index={1}
								item="economyLost"
							/>
						</tr>
						<tr className="stats__row">
							<th
								scope="row"
								className="stats__row__head stats__row__rightHead"
							>
								{summary.players[1].name}
							</th>
							{(extraInfo.leftRelics !== 0 ||
								extraInfo.rightRelics !== 0) && (
								<td className="stats__row__data">
									{extraInfo.rightRelics}
									{extraInfo.leftRelics <
										extraInfo.rightRelics && (
										<span className="text-yellow-400">
											⭐
										</span>
									)}
								</td>
							)}
							<ScoreRow
								players={summary?.players}
								index={1}
								item="maxVillagers"
							/>
							{(summary?.players[0].maxTraders !== 0 ||
								summary?.players[1].maxTraders !== 0) && (
								<ScoreRow
									players={summary?.players}
									index={1}
									item="maxTraders"
								/>
							)}
							{(summary?.players[0].maxFishingShips !== 0 ||
								summary?.players[1].maxFishingShips !== 0) && (
								<ScoreRow
									players={summary?.players}
									index={1}
									item="maxFishingShips"
								/>
							)}
							<ScoreRow
								players={summary?.players}
								index={1}
								item="apm"
							/>
							<ScoreRow
								players={summary?.players}
								index={0}
								item="economyLost"
							/>
						</tr>
					</>
				) : (
					<></>
				)}
			</tbody>
		</table>
	)
}

export { Stats }
